import Resume from 'components/Resume';
import File, { FileTypes } from 'files/File';
import Developer from './index';

export default new File({
    fileType: FileTypes.FILE,
    executable: true,
    name: 'Resume',
    parent: () => Developer,
    data: Resume,
});
